import { components } from 'react-select';


/*
 *  Required to disable Safari autofill
 */
export const AutofillDisabledInput = ({ children, ...props }) => (
    <components.Input {...props} name="search" />
);
